module.exports = "../static/images/1f2f63.gif";